export default "__VITE_ASSET__C37V99FP__"